import React, { Component } from 'react';
import { Container, Message } from 'semantic-ui-react';
import { Form as FormSemanticUI } from 'formsy-semantic-ui-react';
import Formsy from 'formsy-react';

import Introduction from './Introduction';
import CompanyInformation from './CompanyInformation';
import CompanyContactInformation from './CompanyContactInformation';
import ContactPerson from './ContactPerson';
import Other from './Other';
import FormFooter from './FormFooter';

import './index.css';

Formsy.addValidationRule('isURL_custom', function (values, value) {
  if (value) {
    if (
      value.split('.').length > 1 &&
      value.split('.')[0].length > 0 &&
      value.split('.')[1].length > 0
    ) {
      return true;
    }
  }
});

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = { showError: false, isLoading: false };
  }
  onValidSubmit = (history) => async (formData) => {

    this.setState({ isLoading: true})

    window.grecaptcha.ready(async () => {
      window.grecaptcha
        .execute('6LfprHkdAAAAACpLCURUUhqoyVEofmroA5tJ_84-', {
          action: 'submit',
        })
        .then(async (token) => {
          const allData = {
            ...formData,
            oid: '00Db0000000INP0',
            retURL: 'https://bli-medlem.hanen.no/takk',
            '00Nb0000004dyBT': 'Bedriftsmedlemmer',
            member_status: '',
          };

          try {
            const config = {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                reCAPTCHA: token,
              }),
            };

            const response = await fetch(
              'https://api.hanen.no/bli-medlem-Web-to-lead/',
              config
            );
            const data = await response.json();

            if (data.status) {
              const form = document.createElement('form');
              form.method = 'POST';
              form.action =
                'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

              for (let fieldName in allData) {
                if (!allData[fieldName]) {
                  continue;
                }

                let theInput = document.createElement('input');
                theInput.name = fieldName;
                theInput.value = allData[fieldName];
                theInput.setAttribute('type', 'hidden');
                form.appendChild(theInput);
              }
              document.body.appendChild(form);
              form.submit();
            } else {
              console.log(data.message);
              this.setState({ showError: true });
            }

          } catch (error) {
            console.log(error);
            this.setState({ showError: true });

          } finally {
            this.setState({ isLoading: false})
          }
        });
    });
  };

  render() {
    const { IntroduksjonSeksjon, history } = this.props;

    return (
      <Container text>
        <Introduction {...IntroduksjonSeksjon} />
        <FormSemanticUI noValidate onValidSubmit={this.onValidSubmit(history)}>
          <CompanyInformation />
          <CompanyContactInformation />
          <ContactPerson />
          <Other />
          {this.state.showError && (
            <Message negative>
              <Message.Header>
                Beklager men vi kunne ikke fullføre innsendingen av søknaden. Vennligst kontakt oss direkte på post@hanen.no
              </Message.Header>
            </Message>
          )}
          <FormFooter isLoading={this.state.isLoading} />
        </FormSemanticUI>
      </Container>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Form/index.js